import { apiClient } from '../api/client';

/**
 * 회사 글꼴 싣기 (2026-08-18).
 *
 * 관리자가 등록한 글꼴의 `@font-face` 규칙을 서버에서 받아 문서에 한 번 붙인다. 그러면 문서가
 * 들고 온 글꼴 이름("맑은 고딕" 등)을 편집기·미리보기가 **그대로 해석**한다 — 지금까지는
 * 브라우저에 그 글꼴이 없으면 다른 글꼴로 대체돼 줄바꿈·쪽 나눔이 원본과 어긋났다.
 *
 * ⚠ 글꼴 파일 자체는 `@font-face` 안에서 **브라우저가 직접** 받는다(Authorization 헤더를 못
 *   붙인다) — 그래서 서버가 쿠키 인증을 받아 준다. 로고를 `<img src>` 로 쓰는 것과 같은 자리다.
 *
 * 실패는 조용히 넘긴다. 글꼴은 덤이고, 없으면 지금까지와 똑같이 대체 글꼴로 그려진다 —
 * 이것 때문에 화면이 안 뜨는 쪽이 훨씬 나쁘다.
 */

/** 붙여 둔 `<style>` 의 표식 — 두 번 붙지 않게, 그리고 로그아웃 시 걷어낼 수 있게. */
const STYLE_ID = 'wc-custom-fonts';

let installing: Promise<void> | null = null;

export async function installCustomFonts(): Promise<void> {
  if (typeof document === 'undefined') return;
  // 이미 붙어 있으면 다시 받지 않는다(화면을 옮겨 다닐 때마다 요청이 나가지 않게).
  if (document.getElementById(STYLE_ID)) return;
  installing ??= (async () => {
    try {
      const { data } = await apiClient.get<string>('/fonts.css', { responseType: 'text' });
      const css = typeof data === 'string' ? data.trim() : '';
      if (css.length === 0) return;            // 등록된 글꼴이 없다 — 붙일 것도 없다
      if (document.getElementById(STYLE_ID)) return;
      const style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = css;
      document.head.appendChild(style);
    } catch {
      /* 글꼴은 덤 — 실패해도 화면은 그대로 뜬다 */
    } finally {
      installing = null;
    }
  })();
  return installing;
}

/** 로그아웃·계정 전환 때 걷어낸다 — 다음 사용자의 회사 글꼴이 아니다. */
export function removeCustomFonts(): void {
  if (typeof document === 'undefined') return;
  document.getElementById(STYLE_ID)?.remove();
}
